import { useContext } from 'react';
import { AclContext } from './AclContext.js';
import type { AclContextValue } from './AclContext.js';

export function useAcl(): AclContextValue {
  return useContext(AclContext);
}
